import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { formatTimestamp } from './utils';
import { ProjectStatus } from 'src/utils/types';

const Timer = ({
  className,
  remainingTime,
  status,
  disabled
}) => {
  const times = formatTimestamp(remainingTime);

  const renderNumber = (time, label) => /*#__PURE__*/React.createElement("div", {
    className: styles.number
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, time.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false
  })), /*#__PURE__*/React.createElement("span", {
    className: styles.unit
  }, label));

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.title, disabled && styles.disabled)
  }, status === ProjectStatus.UPCOMING ? 'Sale starts in' : 'Sale ends in'), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.timer, disabled && styles.disabled)
  }, renderNumber(times.days, 'Day'), /*#__PURE__*/React.createElement("span", {
    className: styles.colon
  }, ":"), renderNumber(times.hours, 'Hour'), /*#__PURE__*/React.createElement("span", {
    className: styles.colon
  }, ":"), renderNumber(times.minutes, 'Minute'), /*#__PURE__*/React.createElement("span", {
    className: styles.colon
  }, ":"), renderNumber(times.seconds, 'Second')));
};

export default Timer;